export default __webpack_public_path__ + "static/media/ic_forms_active.c608b7fa.svg";